import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircle, ArrowDown } from 'lucide-react';
import { trackWhatsAppClick } from './MetaPixel';
export function Hero() {
  return <section className="relative min-h-screen flex items-center justify-center overflow-hidden" data-id="element-197" data-mp="9kjwmolen43o">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-198" data-mp="4n1jsn49o4qe">
        <img src="https://cdn.magicpatterns.com/uploads/hKBMz5u7RmanGTADrbUsff/ChatGPT_Image_18_may_2026,_10_16_28.png" alt="Freddy Pimentel" className="w-full h-full object-cover object-center" data-id="element-199" data-mp="129h2fs8fj8fj" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink via-ink/90 to-ink/40" data-id="element-200" data-mp="sai16upzuf2k"></div>
        <div className="absolute inset-0 bg-ink/40" data-id="element-201" data-mp="nczr3108ptsz"></div>
      </div>

      <div className="container mx-auto px-6 relative z-10 pt-24 pb-12" data-id="element-202" data-mp="3d1imjfbj1mq2">
        <div className="max-w-3xl" data-id="element-203" data-mp="3czfl7z4xc761">
          <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-serif text-gold leading-[1.1] mb-6 uppercase tracking-wide" initial={{
          opacity: 0,
          y: 30
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} data-id="element-204" data-mp="382p9fo05jxqf">
            Recupera <br className="hidden md:block" data-id="element-205" data-mp="399bcfr77pjxk" />
            <span className="text-ivory-bright" data-id="element-206" data-mp="39cpawocr98zq">Tu Vida</span>
          </motion.h1>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.4,
          ease: [0.16, 1, 0.3, 1]
        }} className="space-y-6 text-lg md:text-xl text-ivory/90 max-w-2xl font-light" data-id="element-207" data-mp="3ebirwqr93i4n">
            <p className="font-serif text-2xl md:text-3xl text-ivory-bright leading-snug" data-id="element-208" data-mp="2qlelycqlb6ah">
              30 días para recuperar tu calma, reconstruir tu seguridad y volver a tomar dirección.
            </p>
            <p className="text-muted text-base md:text-lg leading-relaxed" data-id="element-209" data-mp="2hjymv1586qlk">
              Si una ruptura, una crisis emocional o una etapa de estancamiento te hizo perder el rumbo, este proceso fue creado para ayudarte a volver a ti.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 1,
          delay: 0.6,
          ease: [0.16, 1, 0.3, 1]
        }} className="mt-12 flex flex-col sm:flex-row items-center gap-4" data-id="element-210" data-mp="najfrjc2u5cw">
            <a href="https://wa.me/5491145263003" target="_blank" rel="noopener noreferrer" onClick={trackWhatsAppClick} className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 bg-[#25D366] text-white hover:bg-[#1DA851] transition-all duration-300 font-medium tracking-wide shadow-lg shadow-[#25D366]/20 rounded-xl" data-id="element-211" data-mp="1b1fez1iv42u6">
              <MessageCircle className="w-5 h-5" data-id="element-212" data-mp="3ltqczdtqcxu1" />
              QUIERO RECUPERAR MI VIDA
            </a>
            <a href="#metodo" className="w-full sm:w-auto inline-flex items-center justify-center gap-3 px-8 py-4 border border-white/20 text-ivory hover:bg-white/5 transition-all duration-300 font-medium tracking-wide rounded-xl" data-id="element-213" data-mp="3hpsen5c8br21">
              QUIERO SABER CÓMO FUNCIONA
              <ArrowDown className="w-4 h-4" data-id="element-214" data-mp="268oblkph19t2" />
            </a>
          </motion.div>
          
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 0.8
        }} className="mt-6 text-sm text-muted/80 font-light tracking-wide" data-id="element-215" data-mp="2b20sf8nwscb9">
            Programa de acompañamiento personalizado · Primera edición limitada
          </motion.div>
        </div>
      </div>
    </section>;
}